import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import TranslatedText from 'components/i18n/TranslatedText';
import { TITLE_FONT } from 'style/mixins';
import { DisclosureTriangle } from 'components/header/styles';
import {
  TEXT_100,
  SURFACE_4,
} from 'style/constants';

const StyledButton = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 5px;
  color: ${TEXT_100};
  pointer-events: ${props => (props.open ? 'none' : 'default')};
  ${props => props.open && css`
    & ${DisclosureTriangle} {
      border-top-color: ${TEXT_100};
    }
  `};
  ${TITLE_FONT};
`;

const MenuContainer = styled.div`
  position: relative;
  margin-left: 25px;
`;

const Menu = styled.div`
  position: absolute;
  background-color: ${SURFACE_4};
  right: 0;
  top: 100%;
  min-width: 100%;
  display: ${props => (props.open ? 'block' : 'none')};
  z-index: 50;
`;

export default class NavBurger extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    show: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    children: null,
    className: '',
  };

  state = {
    open: false,
  };

  handleMouseEnter = () => {
    this.setState({
      open: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      open: false,
    });
  };

  handleToggle = () => {
    this.setState(({ open }) => ({ open: !open }));
  };

  render() {
    const { children, className, show } = this.props;
    const { open } = this.state;
    return (
      <MenuContainer
        className={className}
        onClick={this.handleToggle}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        style={show ? undefined : { visibility: 'hidden' }}
      >
        <StyledButton open={open}>
          <TranslatedText stringKey="ACTION_MORE" />
          <DisclosureTriangle expanded={open} />
        </StyledButton>
        <Menu open={open} tabIndex="0">
          { children }
        </Menu>
      </MenuContainer>
    );
  }
}
